import React from 'react'
import { DialogControl } from 'spark-core-dx/components';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';

const ClearAllDialog = ({ isActive, closeDialog }) => {
    const {
        dashboardLib,
    } = useDashboardDomainContext();

    return (
        <DialogControl
            className={"dashboard-dialog"}
            openDialog={isActive}
            title={"Clear All Visuals"}
            onOk={() => {
                closeDialog();
                dashboardLib.clearAllVisuals()
            }}
            onCancel={() => {
                closeDialog();
            }}
            okText={"Clear All"}
        >
            <div className="dialog-text">
                Please confirm that you want to clear all visuals from this dashboard.
            </div>
        </DialogControl>
    )
}

export default ClearAllDialog